import {
  ConfigurationApi,
  configurationApiRef,
} from '@agilelab/plugin-wb-configuration-common';
import { useApi } from '@backstage/core-plugin-api';
import { useQuery as useReactQuery } from '@tanstack/react-query';
import { ConfigSchema as MarketplaceConfigSchema } from '@agilelab/plugin-wb-marketplace-common';
import {
  BuilderCustomPagesEnum,
  MarketplaceCustomPagesEnum,
} from './CustomMicrofrontendConfiguration';
import { ConfigSchema as BuilderConfigSchema } from '@agilelab/plugin-wb-builder-common';

export type MarketplaceCustomPages =
  MarketplaceConfigSchema['fe']['customPages'];
export type BuilderCustomPages = BuilderConfigSchema['fe']['customPages'];

const STALE_TIME = 1000 * 60 * 5;
export const MARKETPLACE_CUSTOM_PAGES_QUERY_KEY = [
  'marketplaceFrontendPluginProjectPageConfig',
];
export const BUILDER_CUSTOM_PAGES_QUERY_KEY = [
  'builderFrontendPluginProjectPageConfig',
];

const marketplaceQueryFn = (wbConfigApi: ConfigurationApi) => async () => {
  return wbConfigApi.get<MarketplaceCustomPages>({
    namespace: 'marketplace',
    key: 'fe.customPages',
  });
};

const builderQueryFn = (wbConfigApi: ConfigurationApi) => async () => {
  return wbConfigApi.get<BuilderCustomPages>({
    namespace: 'builder',
    key: 'fe.customPages',
  });
};

export const useCustomPageConfig = (
  queryFn: any,
  queryKey: any,
  key: MarketplaceCustomPagesEnum | BuilderCustomPagesEnum | undefined,
  noCache?: boolean,
) => {
  const wbConfigApi = useApi(configurationApiRef);
  const { data, isLoading, error } = useReactQuery(
    queryKey,
    queryFn(wbConfigApi),
    {
      staleTime: noCache ? 0 : STALE_TIME,
    },
  );
  return {
    data: key ? (data as Record<string, any>)?.[key] : data,
    isLoading,
    error,
  };
};

//  marketplace
export const useMarketplaceCustomPagesConfig = (
  key: MarketplaceCustomPagesEnum | undefined,
  noCache?: boolean,
) => {
  return useCustomPageConfig(
    marketplaceQueryFn,
    MARKETPLACE_CUSTOM_PAGES_QUERY_KEY,
    key,
    noCache,
  );
};

// builder
export const useBuilderCustomPagesConfig = (
  key: BuilderCustomPagesEnum | undefined,
  noCache?: boolean,
) => {
  return useCustomPageConfig(
    builderQueryFn,
    BUILDER_CUSTOM_PAGES_QUERY_KEY,
    key,
    noCache,
  );
};
